import { Table } from "antd";
import { debounce } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import apiCall from "../../components/Api";
import AddButton from "../../components/Common/addButton";
import FilterOptions from "../../components/Common/antdFilterOptions";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import Pagination from "../../components/Common/CommonPagination";
import MainconternLayout from "../../components/Layout/MainconternLayout";

const MedicinesAssets = () => {
  const navigate = useNavigate();
  const [pages, setPages] = useState(0);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(50);
  const [sort, setSort] = useState("newest");
  const [records, setRecords] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [pageOffset, setPageOffset] = useState(0);

  useEffect(() => {
    list_api_call();
  }, [limit, sort, skip, searchText]);

  const handlePageChange = (event) => {
    setSkip(event.selected * limit);
    setPageOffset(event.selected);
  };

  const list_api_call = async () => {
    try {
      const response = await apiCall(
        `medicine/images?page=${skip}&limit=${limit}&sortBy=${sort}&searchText=${searchText}`,
        "GET",
      );
      setRecords(response.data);
      setPages(Math.ceil(response.data.total / limit));
    } catch (err) {
      console.error(err);
      alert("Some error");
    }
  };

  const handleManufacturerForm = () => {
    navigate("/healthsy-services/order-medicines/upload-assets");
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => Number(skip || 0) + (index + 1),
      key: "serial",
      width: 80,
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 100,
      render: (text, record) => (
        <img
          src={process.env.REACT_APP_API_URL + "medicines/" + record.name} // Adjust path based on your setup
          alt={record.name}
          style={{
            width: "150px",
            height: "150px",
            objectFit: "cover",
            borderRadius: "5px",
          }}
        />
      ),
    },
    {
      title: "Image Name",
      dataIndex: "image",
      key: "image_name",
      width: 200,
      render: (text, record) => <span>{record.name}</span>,
    },
  ];

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
  };
  const debouncedSearch = debounce((value) => {
    handlePageChange({ selected: 0 });
    setSearchText(value);
  }, 500);

  const onChangeSearch = (value) => {
    debouncedSearch(value);
  };

  const formatTitle = (segment) => {
    return segment
      .replace(/-/g, " ") // Replace dashes with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter
  };

  // const breadcrumbsList = useMemo(() => {
  //   const pathSegments = location.pathname.split("/").filter(Boolean); // Remove empty segments

  //   return pathSegments.map((segment, index) => {
  //     const link = `/${pathSegments.slice(0, index + 1).join("/")}`; // Create breadcrumb link
  //     return { text: formatTitle(segment), link };
  //   });
  // }, [location.pathname]);

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Healthsy Services",
        link: "/healthsy-services/order-medicines/medicine-details",
      },
      {
        text: "Order Medicines",
        link: "/healthsy-services/order-medicines/medicine-details",
      },
      {
        text: "Assets",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={breadcrumbsList}
            />
            <div className="d-flex gap-4 align-items-center">
              <div className="bgPrimary addBtn">
                <AddButton
                  onClick={handleManufacturerForm}
                  addBtn={true}
                  btnContent="Upload Assests"
                />
              </div>
            </div>
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              {" "}
              Total Images: {records.total}
            </div>
            {records.total >= limit && (
              <Pagination
                skip={skip}
                limit={limit}
                total={pages * limit}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          {/* <NavBarTitles titles={navBarData} /> */}
          <FilterOptions
            limit={limit}
            handleSortClick={handleSortClick}
            setLimit={setLimit}
            filterBy={false}
            onChangeSearch={onChangeSearch}
          />
          <Table
            columns={columns}
            dataSource={records.data}
            pagination={false}
            rowKey="_id"
            className="mx-3 pt-2 table-scrollable medicineList_table"
            // style={{ height: "475px" }}
            scroll={{ x: "max-content" }}
          />
        </div>
      </MainconternLayout>
    </>
  );
};

export default MedicinesAssets;
